import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

// Firebase
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from 'angularfire2/storage';
import { map } from 'rxjs/operators/map';
import { v1 } from 'uuid';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {

  @Input() title: string;
  // Set static name to file
  // !externalFileName => original name
  // externalFileName => static custom name
  @Input() externalFileName: string;
  // Image name
  // !imageName => create
  // imageName => edit
  @Input() imageName: string;
  @Input() folder: string;
  message: string;
  @Output() uploadedImageName = new EventEmitter<string>();
  fileName: string;

  // Firebase
  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  uploadProgress: Observable<number>;
  downloadURL: Observable<string>;
  uploadState: Observable<string>;

  progress = 'progress hidden';
  _validFileExtensions = ["image/jpg", "image/jpeg", "image/bmp", "image/png"];
  validation_type_file: boolean;
  validation_size: boolean;
  file_size: string;
  file_name: string;
  limit_bytes: number = 1000000;

  status_success: boolean = false;
  status_message: string;
  b64_image: string;
  imgURL: string;

  constructor(
    private afStorage: AngularFireStorage,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.getImage(this.imageName);
  }
  getImage(image: string): void {
    if (image) {
      this.imgURL = `${environment.URL_IMAGE}${this.folder}%2F${image}?alt=media`;
    }
  }
  getDefaultImage(): void {
    this.imgURL = `${environment.URL_IMAGE}${this.folder}%2Fdefault.png?alt=media`;
  }

  activeInputFile(inputFile): void {
    inputFile.click();
  }

  upload(event): void {
    const file = event.target.files[0];
    this.fileName = file.name;
    const validation = this.validateTypeFile(file);
    this.validation_type_file = validation;

    if (validation === true && this.limit_bytes >= file.size) {
      this.file_size = this.formatBytes(file.size, 2);
      this.file_name = file.name;
      if (this.limit_bytes >= file.size) {
        this.validation_size = true;
      } else {
        this.validation_size = false;
      }

      const newName = v1();
      const ext = file.name.split('.').pop();
      const metadata = {
        customMetadata: {
          'newName': `${newName}.${ext}`,
        }
      };

      let basePath = '';
      if (this.externalFileName === 'staticFolder') {
        basePath = `${environment.env}/${this.folder}/${file.name}`;
      } else if (this.externalFileName && this.externalFileName !== 'staticFolder') {
        basePath = `${environment.env}/${this.folder}/${this.externalFileName}`;
      } else {
        basePath = `source/${environment.env}/${this.folder}/${file.name}`;
      }

      this.ref = this.afStorage.ref(basePath);
      this.task = this.ref.put(event.target.files[0], metadata);
      this.uploadState = this.task.snapshotChanges().pipe(map(s => s.state));
      this.uploadProgress = this.task.percentageChanges();
      this.downloadURL = this.task.downloadURL();

      this.downloadURL.subscribe(data => {
        if (data) {
          this.imgURL = data;
        }
      });

      this.uploadProgress.subscribe(data => {
        this.progress = 'progress';
        if (data == 100) {
          this.status_message = 'Carga correcta.';
          if (this.externalFileName === 'staticFolder') {
            this.b64_image = this.fileName;
          } else if (this.externalFileName && this.externalFileName !== 'staticFolder') {
            this.b64_image = this.externalFileName;
          } else {
            this.b64_image = `${newName}.${ext}`;
          }
          this.onSubmitUploadedImageName(this.b64_image);
          setTimeout(() => {
            this.progress = 'progress hidden';
            this.showSuccessImage(this.status_message);
          }, 1000);
        }
      });
    } else {
      this.file_size = this.formatBytes(file.size, 2);
      this.file_name = file.name;
      if (this.limit_bytes >= file.size) {
        this.validation_size = true;
      } else {
        this.validation_size = false;
      }
    }
  }

  onSubmitUploadedImageName(slider: string): void {
    this.uploadedImageName.emit(slider);
  }

  validateTypeFile(file): boolean {
    if (file) {
      let count_true = 0;
      this._validFileExtensions.forEach(type_file => {
        if(type_file === file.type) {
          count_true++;
        }
      });

      if (count_true > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  formatBytes(bytes,decimals): string {
    if(bytes == 0) {
      return '0 Bytes';
    }
    var k = 1024,
        dm = decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  showSuccessImage(message: string): void {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-bottom-right'
    });
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/shared/upload/upload.component.ts